import baseApi from './base';

const fetchAll = () =>
  baseApi.request({
    method: 'get',
    url: '/departs'
  });

const createOne = data =>
  baseApi.request({
    method: 'post',
    url: '/departs',
    data
  });

const modifyOne = data =>
  baseApi.request({
    method: 'patch',
    url: `/departs/${data.id}`,
    data
  });

const deleteAll = data =>
  baseApi.request({
    method: 'delete',
    url: '/departs',
    data
  });

export {
  fetchAll,
  createOne,
  modifyOne,
  deleteAll
};



// WEBPACK FOOTER //
// ./src/api/depart.js